/**
 * @author Vivek Kumar <vivek.kumar@gmail.com>
 * @description X12 Claim Adjustment Reason Codes with structured data
 */
import reasonCodes from './reasonCodes.json';

// X12 Claim Adjustment Group Codes
const GROUP_CODES: { code: 'CO' | 'PR' | 'PI' | 'OA'; display: string }[] = [
	{
		code: 'CO',
		display: 'Contractual Obligation',
	},
	{
		code: 'PR',
		display: 'Patient Responsibility',
	},
	{
		code: 'PI',
		display: 'Payor Initiated Reduction',
	},
	{
		code: 'OA',
		display: 'Other Adjustment',
	},
];

const ADJUSTMENT_GROUP_CODES = ['CO', 'PI', 'OA'];

const PATIENT_RESPONSIBILITIES_GROUP_CODES = ['PR'];

const BILLED_AMOUNT_CODES = ['submitted'];

const PAID_AMOUNT_CODES = ['paid', 'benefit'];

// X12 Claim Adjustment Reason Codes with structured data
const REASON_CODES = reasonCodes;

export { GROUP_CODES, REASON_CODES, ADJUSTMENT_GROUP_CODES, PATIENT_RESPONSIBILITIES_GROUP_CODES, BILLED_AMOUNT_CODES, PAID_AMOUNT_CODES };
